import React, { useMemo, useState } from 'react'
import RightContent from '../../components/OnBoard/RightContent'
import styles from "./UserOnboarding2.module.css"
import UserOnboardingSteps from '../../components/OnBoard/UserOnboardingSteps'
import style from "./BusinessDetailsOverseas.module.css"
import { Country } from 'country-state-city'
import { useNavigate } from 'react-router-dom'
import API from "../../ApiConfig"
import { SIGNUP_VERIFER } from '../../Utils/constant'
import cogoToast from 'cogo-toast-react-17-fix'
import { OVERSEAS_PHONE_CHECK, PASSWORD_CHECK, PHONE_CHECK } from '../../Utils/helper'
import AnimatedLoader from '../../components/AnimationLoader'
import Icon from 'react-icons-kit'
import { basic_eye } from 'react-icons-kit/linea/basic_eye'
import { basic_eye_closed } from 'react-icons-kit/linea/basic_eye_closed'
const BusinessDetailsOverseas = () => {
  const allCountries = Country.getAllCountries();
  const user_data=JSON.parse(localStorage.getItem("user_data"))
  const [loading, setLoading]=useState(false)
  const [errors, setErrors] = useState({})
  const [form, setForm] = useState({
    tin: "", company: "", addr1: "", addr2: "", country: "", zip: "", password:"",confirmPassword:"", phoneNumber:""
  })
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const navigate=useNavigate()


  const set = (k) => (e) =>{ setForm(f => ({ ...f, [k]: e.target.value }));
  if (errors[k]) setErrors(prev => ({ ...prev, [k]: "" }))
};
const handleCountryChange = (e) => {
  setForm(f => ({ ...f, country: e.target.value, phoneNumber: "" }))
  if (errors.country) setErrors(prev => ({ ...prev, country: "" }))
  if (errors.phoneNumber) setErrors(prev => ({ ...prev, phoneNumber: "" }))
}

const handlePhoneChange = (e) => {
  const digits = e.target.value.replace(/\D/g, "")
  setForm(f => ({ ...f, phoneNumber: digits }))
  if (errors.phoneNumber) setErrors(prev => ({ ...prev, phoneNumber: "" }))
}
const selectedCountry = useMemo(
  () => allCountries.find(c => c.name === form.country),
  [form.country, allCountries]
)
const dialCode = selectedCountry?.phonecode? (selectedCountry.phonecode.startsWith("+") ? selectedCountry.phonecode : `+${selectedCountry.phonecode}`): ""



const validateForm = () => {
  const newErrors = {}

  // TIN/VAT
  if (!form.tin.trim()) {
    newErrors.tin = "TIN / VAT Number is required"
  } else if (form.tin.trim().length < 5) {
    newErrors.tin = "TIN / VAT Number looks too short"
  }
  if (!form.company.trim()) {
    newErrors.company = "Company name is required"
  } else if (form.company.trim().length < 3) {
    newErrors.company = "Company name is too short"
  }
  if (!form.password) {
    newErrors.password = "Password is required"
  }
   else if (!PASSWORD_CHECK(form.password)){
    newErrors.password = "Your password should be between 8 to 13 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character!!"
   }
   if (!form.confirmPassword) {
    newErrors.confirmPassword = "Please confirm your password"
  } else if (form.password !== form.confirmPassword) {
    newErrors.confirmPassword = "Passwords do not match"
  }

  if (!form.phoneNumber.trim()) {
    newErrors.phoneNumber = "Phone number is required"
  }
  else if (!OVERSEAS_PHONE_CHECK(form.phoneNumber)){
    newErrors.phoneNumber = "Enter a valid phone number"
  }
  if (!form.addr1.trim()) {
    newErrors.addr1 = "Address Line 1 is required"
  }
  if(form.addr1.trim().length > 100){
    newErrors.addr1 = "Address Line 1 cannot exceed 100 characters"
  }
  if(form.addr1.trim().length<3){
    newErrors.addr1 = "Address Line 1 should have minumum 3 characters"
  }
  if (!form.addr2.trim()) {
    newErrors.addr2 = "Address Line 2 is required"
  }
  if(form.addr2.trim().length > 100){
    newErrors.addr2 = "Address Line 2 cannot exceed 100 characters"
  }
  if(form.addr2.trim().length<3){
    newErrors.addr2 = "Address Line 2 should have minumum 3 characters"
  }
  if (!form.country) {
    newErrors.country = "Please select a country"
  }
  if (!form.zip.trim()) {
    newErrors.zip = "Zip / Postal code is required"
  } else if (form.zip.trim().length < 3) {
    newErrors.zip = "Zip code looks too short"
  }
  
  setErrors(newErrors)
  return Object.keys(newErrors).length === 0

}
  const handleSubmit=(e)=>{
    e.preventDefault()
    if (!validateForm()) {
      cogoToast.error("Please fix the errors in the form")
      return;
    }
    if (!user_data?.email) {
      cogoToast.error("Session expired. Please restart registration.")
      navigate("/app/Onboarding")
      return;
    }
    let apiData={
        email: user_data.email,
        phone_number:dialCode+form.phoneNumber,
        jurisdiction_type: "overseas",
        company_name: form.company,
        address1: form.addr1,
        address2: form.addr2,
        country: form.country,
        pincode: form.zip,
        password: form.password,
        confirm_password: form.confirmPassword,
        tin_vat_number: form.tin,
        billing_address_option: "same"
        }
    setLoading(true)
    API.post(SIGNUP_VERIFER,apiData)
    .then(res=>{
      setLoading(false)
      if(res.status=200){
        cogoToast.success(res.data.message)
        navigate("/app/registration/step3")
      }


      else {
        cogoToast.error(res.data.message || "Something went wrong")
      }
    })
    .catch(err=>{
      if(err.response.status==408){
                  setLoading(false)
                  cogoToast.error(err?.response?.data?.message)
                  navigate("/app/Onboarding")
                }
                else{
                setLoading(false)
                cogoToast.error(err?.response?.data?.message || "Something went wrong")
                }
      
    })
  }
  return (
    <div>
      <AnimatedLoader isOpen={loading} loadingText={"Please Wait..."}/>
    <div className={styles.userOnboarding}>
    <RightContent step={3} />
     <section className={styles.leftContent}>
            <div className={styles.progressForm} style={{height:"100%", width:"75%",padding:"3rem 1.25rem"}}>
              <div className={styles.progressForm1}>
              <div className={styles.onboardingStep}>
                        <UserOnboardingSteps stepNo={2}/>
                    </div>
                <div className={styles.headingHelperText}>
                    <h1 className={styles.heading} style={{fontSize:"30px", textAlign:"left"}}>Business Details</h1>
                    <div>
                        <p className={styles.supportingText} style={{textAlign:"center", marginTop:"0px"}}>Provide legal and operational information for your overseas entity.</p>
                    </div>
                     <div className={styles.emailContainer} style={{width:"100%"}}>
 
              <div className={style.anFormRow}>
                <div className={style.anFormGroup}>
                  <label className={style.anLabel}>Tax Identification Number (TIN) / VAT Number <span style={{color:"red"}}>*</span></label>
                  <input
                    className={style.anInput}
                    placeholder="e.g. EU123456789"
                    value={form.tin}
                    onChange={set("tin")}
                  />
                  {errors.tin && (
                    <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                      {errors.tin}
                    </span>
                  )}
                </div>
                <div className={style.anFormGroup}>
                  <label className={style.anLabel}>Company Name <span style={{color:"red"}}>*</span></label>
                  <input
                    className={style.anInput}
                    placeholder="Legal registered name"
                    value={form.company}
                    onChange={set("company")}
                  />
                  {errors.company && (
                    <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                      {errors.company}
                    </span>
                  )}
                </div>
              </div>
              <div className={style.anFormRow}>
                <div className={style.anFormGroup}>
                  <label className={style.anLabel}>Password <span style={{color:"red"}}>*</span></label>
                  <div className={style.anInput} style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="e.g. 123456789"
                    value={form.password}
                    onChange={set("password")}
                    style={{
                      width: "100%",
                      height:"46px",
                      border: "none",
                      outline: "none",
                      background: "transparent",
                      padding: "0px",
                      fontSize: "14px",
                    }}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: 12,
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6b7280",
                      display: "flex",
                      alignItems: "center",
                  }} ><Icon icon={showPassword? basic_eye:basic_eye_closed} size={20}/></span>
                  </div>
                  {errors.password && (
                    <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                      {errors.password}
                    </span>
                  )}
                </div>
                <div className={style.anFormGroup}>
                  <label className={style.anLabel}>Confirm Password <span style={{color:"red"}}>*</span></label>
                  <div className={style.anInput} style={{position:"relative"}}>
                  <input
                  type={showConfirmPassword?"text":"password"}
                    placeholder="Re-Enter your password"
                    value={form.confirmPassword}
                    onChange={set("confirmPassword")}
                    style={{
                      width: "100%",
                      height:"46px",
                      border: "none",
                      outline: "none",
                      background: "transparent",
                      padding: "0px",
                      fontSize: "14px",
                    }}
                  />
                  <span
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: "absolute",
                      right: 12,
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6b7280",
                      display: "flex",
                      alignItems: "center",
                  }} ><Icon icon={showConfirmPassword? basic_eye:basic_eye_closed} size={20}/></span>
                  </div>
                  {errors.confirmPassword && (
                    <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                      {errors.confirmPassword}
                    </span>
                  )}
                </div>
              </div>


               <div>
                                  <p className={styles.supportingText} style={{color:"#1a56db",margin:"15px 0px", fontWeight:"500"}}>BILLING ADDRESS</p>
                            </div>
              <div className={style.anFormGroup}>
                <label className={style.anLabel}>Address Line 1 <span style={{color:"red"}}>*</span></label>
                <input
                  className={style.anInput}
                  placeholder="Street address or P.O. Box"
                  value={form.addr1}
                  onChange={set("addr1")}
                />
                {errors.addr1 && (
                  <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                    {errors.addr1}
                  </span>
                )}
              </div>
 
              <div className={style.anFormGroup}>
                <label className={style.anLabel}>Address Line 2 <span style={{color:"red"}}>*</span></label>
                <input
                  className={style.anInput}
                  placeholder="Apartment, suite, unit, building, floor, etc."
                  value={form.addr2}
                  onChange={set("addr2")}
                />
                {errors.addr2 && (
                  <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                    {errors.addr2}
                  </span>
                )}
              </div>
 
              <div className={style.anFormRow}>
                <div className={style.anFormGroup} style={{ marginBottom: 0 }}>
                  <label className={style.anLabel}>Country <span style={{color:"red"}}>*</span></label>
                  <div className={style.anSelectWrap}>
                    <select
                      className={`${style.anSelect}${form.countryCode ? style.hasValue : ""}`}
                      value={form.country}
                      onChange={handleCountryChange}
                    >
                      <option value="">Select country</option>
                      {allCountries &&allCountries.map(c => <option key={c.isoCode} value={c.name}>{c.flag} {c.name}</option>)}
                    </select>
                    <span className={style.anSelectArrow}>▾</span>
                  </div>
                  {errors.country && (
                    <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                      {errors.country}
                    </span>
                  )}
                </div>
                <div className={style.anFormGroup} style={{ marginBottom: 0 }}>
                  <label className={style.anLabel}>Zip Code <span style={{color:"red"}}>*</span></label>
                  <input
                    className={style.anInput}
                    placeholder="Postal code"
                    value={form.zip}
                    onChange={set("zip")}
                  />
                  {errors.zip && (
                    <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                      {errors.zip}
                    </span>
                  )}
                </div>
                <div className={style.anFormGroup}>
                  <label className={style.anLabel}>Phone Number <span style={{color:"red"}}>*</span></label>
                  <div
                        className={style.anInput}
                        style={{ display: "flex", alignItems: "center", padding: 0, overflow: "hidden" }}
                      >
                        <span
                          style={{
                            padding: "0 12px",
                            height: "46px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#e5e7eb",
                            color: dialCode ? "#374151" : "#9ca3af",
                            fontSize: "14px",
                            fontWeight: 500,
                            borderRight: "1px solid #d1d5db",
                            userSelect: "none",
                            cursor: "not-allowed",
                            minWidth: "60px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {dialCode || "+--"}
                        </span>
                  <input
                  style={{width:"100%", border:"0px"}}
                    className={style.anInput}
                    placeholder="eg. 9876543210"
                    value={form.phoneNumber}
                    maxLength={15}
                    disabled={!form.country}
                    onChange={handlePhoneChange}
                  />
                  </div>
                  {errors.phoneNumber && (
                    <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                      {errors.phoneNumber}
                    </span>
                  )}
                </div>
              </div>
 
              <div className={style.anActions} style={{ marginTop: 32 }}>
                <button className={style.anBtnBack} onClick={()=>navigate("/app/registration/step4")} disabled={loading}>← Back</button>
                <button className='btn btn-primary' onClick={(e)=>handleSubmit(e)} disabled={loading}>{loading ? "Saving..." : "Save & Continue"}</button>
              </div>
            </div>
                    </div>
                    </div>
                </div>
     </section>
     </div>
     </div>
  )
}

export default BusinessDetailsOverseas